import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { AdminPanelSalesFilterRequestDto } from "../../../api/apiServices/backOffice/controllers/adminPanel/adminPanel.requestsDto";
import {
  AdminPanelClientsGrossResponseDto,
  AdminPanelClientsWithoutAttentionResponseDto,
  AdminPanelClosingDebtsResponseDto,
  AdminPanelCurrentClientsResponseDto,
  AdminPanelGeneralAnalysisResponseDto,
  AdminPanelManagersGrossResponseDto,
  AdminPanelSalesDealsResponseDto,
} from "../../../dto/AdminPanel/AdminPanelSalesReportsResponseDto";

const initialState = {
  currentClientsLoading: true,
  currentClientsError: false,
  currentClients: undefined as AdminPanelCurrentClientsResponseDto | undefined,
  clientsWithoutAttentionLoading: true,
  clientsWithoutAttentionError: false,
  clientsWithoutAttention: undefined as AdminPanelClientsWithoutAttentionResponseDto | undefined,
  dealsLoading: true,
  dealsError: false,
  deals: undefined as AdminPanelSalesDealsResponseDto | undefined,
  closingDebtsLoading: true,
  closingDebtsError: false,
  closingDebts: undefined as AdminPanelClosingDebtsResponseDto | undefined,
  generalAnalysisLoading: true,
  generalAnalysisError: false,
  generalAnalysis: undefined as AdminPanelGeneralAnalysisResponseDto | undefined,
  managersGrossLoading: true,
  managersGrossError: false,
  managersGross: undefined as AdminPanelManagersGrossResponseDto | undefined,
  clientsGrossLoading: true,
  clientsGrossError: false,
  clientsGross: undefined as AdminPanelClientsGrossResponseDto | undefined,
};

const salesReportsSlice = createSlice({
  name: "adminPanelSalesReports",
  initialState,
  reducers: {
    loadSalesCurrentClients(state, _action: PayloadAction<AdminPanelSalesFilterRequestDto>) {
      state.currentClientsLoading = true;
      state.currentClientsError = false;
    },
    loadSalesCurrentClientsSuccess(state, action: PayloadAction<AdminPanelCurrentClientsResponseDto>) {
      state.currentClientsLoading = false;
      state.currentClients = action.payload;
    },
    loadSalesCurrentClientsFailure(state) {
      state.currentClientsLoading = false;
      state.currentClientsError = true;
    },
    loadSalesClientsWithoutAttention(state, _action: PayloadAction<AdminPanelSalesFilterRequestDto>) {
      state.clientsWithoutAttentionLoading = true;
      state.clientsWithoutAttentionError = false;
    },
    loadSalesClientsWithoutAttentionSuccess(state, action: PayloadAction<AdminPanelClientsWithoutAttentionResponseDto>) {
      state.clientsWithoutAttentionLoading = false;
      state.clientsWithoutAttention = action.payload;
    },
    loadSalesClientsWithoutAttentionFailure(state) {
      state.clientsWithoutAttentionLoading = false;
      state.clientsWithoutAttentionError = true;
    },
    loadSalesDeals(state, _action: PayloadAction<AdminPanelSalesFilterRequestDto>) {
      state.dealsLoading = true;
      state.dealsError = false;
    },
    loadSalesDealsSuccess(state, action: PayloadAction<AdminPanelSalesDealsResponseDto>) {
      state.dealsLoading = false;
      state.deals = action.payload;
    },
    loadSalesDealsFailure(state) {
      state.dealsLoading = false;
      state.dealsError = true;
    },
    loadSalesClosingDebts(state, _action: PayloadAction<AdminPanelSalesFilterRequestDto>) {
      state.closingDebtsLoading = true;
      state.closingDebtsError = false;
    },
    loadSalesClosingDebtsSuccess(state, action: PayloadAction<AdminPanelClosingDebtsResponseDto>) {
      state.closingDebtsLoading = false;
      state.closingDebts = action.payload;
    },
    loadSalesClosingDebtsFailure(state) {
      state.closingDebtsLoading = false;
      state.closingDebtsError = true;
    },
    loadSalesGeneralAnalysis(state, _action: PayloadAction<AdminPanelSalesFilterRequestDto>) {
      state.generalAnalysisLoading = true;
      state.generalAnalysisError = false;
    },
    loadSalesGeneralAnalysisSuccess(state, action: PayloadAction<AdminPanelGeneralAnalysisResponseDto>) {
      state.generalAnalysisLoading = false;
      state.generalAnalysis = action.payload;
    },
    loadSalesGeneralAnalysisFailure(state) {
      state.generalAnalysisLoading = false;
      state.generalAnalysisError = true;
    },
    loadSalesManagersGross(state, _action: PayloadAction<AdminPanelSalesFilterRequestDto>) {
      state.managersGrossLoading = true;
      state.managersGrossError = false;
    },
    loadSalesManagersGrossSuccess(state, action: PayloadAction<AdminPanelManagersGrossResponseDto>) {
      state.managersGrossLoading = false;
      state.managersGross = action.payload;
    },
    loadSalesManagersGrossFailure(state) {
      state.managersGrossLoading = false;
      state.managersGrossError = true;
    },
    loadSalesClientsGross(state, _action: PayloadAction<AdminPanelSalesFilterRequestDto>) {
      state.clientsGrossLoading = true;
      state.clientsGrossError = false;
    },
    loadSalesClientsGrossSuccess(state, action: PayloadAction<AdminPanelClientsGrossResponseDto>) {
      state.clientsGrossLoading = false;
      state.clientsGross = action.payload;
    },
    loadSalesClientsGrossFailure(state) {
      state.clientsGrossLoading = false;
      state.clientsGrossError = true;
    },
  },
});

export default salesReportsSlice;
